module.exports = __webpack_public_path__ + "img/clay_concrete_shingles_tiles.a563898a.jpg";